import { ObserversModule } from '@angular/cdk/observers'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'
import { AiPreviewAreaHeaderComponent } from '../preview-area-header/preview-area-header.component'

@Component({
  selector: 'flx-ai-preview-area',
  imports: [AiIconsModule, ObserversModule, AiPreviewAreaHeaderComponent],
  templateUrl: './preview-area.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./preview-area.component.scss'],
})
export class AiPreviewAreaComponent {
  title = input('')
  hasInfoButton = input(false)
  ignorePadding = input(false)
}
